<template>
  <div class="ym-tab">
    <div class="item" :class="{ active: props.modelValue == item.id }" v-for="item in props.data" :key="item[props.fieldNames.key]" @click="handleItem(item)">
      <slot name="default" :row="item">{{ item[props.fieldNames.label] }}</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
interface IProps {
  data: { [key: string]: any }[]
  fieldNames?: {
    key: string
    label: string
  }
  modelValue: string | number
}

const props = withDefaults(defineProps<IProps>(), {
  fieldNames: () => {
    return {
      key: 'id',
      label: 'label'
    }
  }
})

const emits = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'change', value: string): void
}>()

const handleItem = (item) => {
  emits('update:modelValue', String(item[props.fieldNames.key]))
  emits('change', String(item[props.fieldNames.key]))
}
</script>

<style scoped lang="scss">
.ym-tab {
  display: flex;
  align-items: center;
  gap: 12px;
  .item {
    height: 32px;
    padding: 0 12px;
    line-height: 32px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    border-radius: 5px;
    &:hover:not(.active) {
      color: #01ac68;
    }
    &.active {
      background-image: linear-gradient(to right, #0ec15e, #8bdd45);
      color: #ffffff;
      font-weight: bold;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid #34d058;
      }
    }
  }
}
</style>
